<template>
    <div id="features" class="max-w-screen-xl px-4 pb-16 mx-auto sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
        <div class="pb-8 overflow-hidden lg:py-8">
            <div class="relative mt-12 lg:mt-20 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                <div class="relative">
                    <h4 class="text-2xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-3xl sm:leading-9">
                        Team Status Dashboard
                    </h4>
                    <p class="mt-3 text-lg leading-7 text-gray-500">
                        Your teammates check in daily, and you see your whole team's status at a glance.
                    </p>

                    <ul class="mt-10">
                        <li>
                            <div class="flex">
                                <div class="flex-shrink-0">
                                    <div class="flex items-center justify-center w-12 h-12 text-white rounded-md bg-primary-500">
                                        <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="ml-4">
                                    <h5 class="text-lg font-medium leading-6 text-gray-900">Quick status updates</h5>
                                    <p class="mt-2 text-base leading-6 text-gray-500">See what's being worked by your whole team (done, doing, blocked)</p>
                                </div>
                            </div>
                        </li>
                        <li class="mt-10">
                            <div class="flex">
                                <div class="flex-shrink-0">
                                    <div class="flex items-center justify-center w-12 h-12 text-white rounded-md bg-primary-500">
                                        <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div class="ml-4">
                                    <h5 class="text-lg font-medium leading-6 text-gray-900">Simple collobarotion</h5>
                                    <p class="mt-2 text-base leading-6 text-gray-500">Upload images and share your work with the whole team</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="relative mt-10 lg:-mx-4 lg:mt-0">
                    <img class="relative mx-auto" width="490" src="../assets/flow-card-v2.svg" alt="" />
                </div>
            </div>
            <div class="relative mt-12 sm:mt-16 lg:mt-24">
                <div class="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
                    <div class="lg:col-start-2">
                        <h4 class="text-2xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-3xl sm:leading-9">
                            Team Announcements
                        </h4>
                        <p class="mt-3 text-lg leading-7 text-gray-500">
                            Make announcements, and share achievements with the whole team! Celebrate your team's work and grow your culture.
                        </p>

                        <ul class="mt-10">
                            <li>
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <div class="flex items-center justify-center w-12 h-12 text-white rounded-md bg-lg-500">
                                            <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="ml-4">
                                        <h5 class="text-lg font-medium leading-6 text-gray-900">Share announcements</h5>
                                        <p class="mt-2 text-base leading-6 text-gray-500">Share team accomplishments and keep your team up to date with announcements</p>
                                    </div>
                                </div>
                            </li>
                            <li class="mt-10">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <div class="flex items-center justify-center w-12 h-12 text-white rounded-md bg-lg-500">
                                            <svg class="w-6 h-6 fill-current" viewBox="0 0 24 24">
                                                <path
                                                    d="M14,11H13V10a1,1,0,0,0-2,0v1H10a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V13h1a1,1,0,0,0,0-2Zm6.16-6A6.29,6.29,0,0,0,12,4.41a6.27,6.27,0,0,0-8.16,9.48l6,6.05a3,3,0,0,0,4.24,0l6-6.05A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6,6a1,1,0,0,1-1.42,0l-6-6a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.48Z"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="ml-4">
                                        <h5 class="text-lg font-medium leading-6 text-gray-900">Build a culture of support</h5>
                                        <p class="mt-2 text-base leading-6 text-gray-500">Celebrate your team, and individual progress, with shared vision and collaboration</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="relative mt-10 lg:-mx-4 lg:mt-0 lg:col-start-1">
                        <img class="relative mx-auto" width="490" src="../assets/announcement.svg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app-features',
};
</script>
<style scoped>
.bg-lg-500 {
    background-color: #38d39f;
}
</style>
